import { useMutation } from '@tanstack/react-query';
import { oracleRepository } from '../../repositories/oracle-repository';
import { CreateOpportunityParams } from '../../interfaces/opportunity';

export const useCreateOpportunity = () => {
  const validateRecaptchaOpportunity = async (
    data: CreateOpportunityParams,
  ) => {
    return oracleRepository.opportunityCreation(data);
  };

  return useMutation(
    async (data: CreateOpportunityParams) =>
      await validateRecaptchaOpportunity(data),
  );
};
